<template>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="width"
      :height="height"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10.4862 2.2325L5.49625 4.1025C4.34625 4.5325 3.40625
         5.89248 3.40625 7.12248V14.5525C3.40625
         15.7325 4.18626 17.2825 5.13626 17.9925L9.43625 21.2025C10.8462
          22.2625 13.1662 22.2625 14.5762
          21.2025L18.8763 17.9925C19.8263 17.2825 20.6062 15.7325 20.6062
           14.5525V7.12248C20.6062 5.89248
           19.6662 4.5325 18.5162 4.1025L13.5262 2.2325C12.6762 1.9225
            11.3162 1.9225 10.4862 2.2325Z"
        :stroke="color ? color : theme === 'light' ? 'var(--color-icon)' : 'var(--color-icon)'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9997 10.9185C11.9597 10.9185 11.9097 10.9185 11.8697
         10.9185C10.9297 10.8885 10.1797 10.1084
         10.1797 9.15845C10.1797 8.18845 10.9697 7.39844 11.9397
          7.39844C12.9097 7.39844 13.6997 8.18845
          13.6997 9.15845C13.6897 10.1184 12.9397 10.8885 11.9997 10.9185Z"
        :stroke="color ? color : theme === 'light' ? 'var(--color-icon)' : 'var(--color-icon)'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.0091 13.7194C9.04906 14.3594 9.04906 15.4094 10.0091
         16.0494C11.0991 16.7794 12.8891 16.7794 13.9791
         16.0494C14.9391 15.4094 14.9391 14.3594 13.9791 13.7194C12.8991
          12.9894 11.1091 12.9894 10.0091 13.7194Z"
        :stroke="color ? color : theme === 'light' ? 'var(--color-icon)' : 'var(--color-icon)'"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({ theme: 'getTheme' }),
  },
  props: {
    color: {
      type: String,
    },
    width: {
      type: String,
      default: '24',
    },
    height: {
      type: String,
      default: '24',
    },
  },
};
</script>
